/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreAggregatorStatusResponse } from '../../models/store-aggregator-status-response';

export interface AggregatorStoreStatusGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;

/**
 * Aggregator identifier
 */
  aggregatorId: 'ubereats' | 'doordash';
}

export function aggregatorStoreStatusGet(http: HttpClient, rootUrl: string, params: AggregatorStoreStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, aggregatorStoreStatusGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('aggregatorId', params.aggregatorId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreAggregatorStatusResponse>;
    })
  );
}

aggregatorStoreStatusGet.PATH = '/stores/{storeId}/status/{aggregatorId}';
